import { PropsWithChildren } from "react";

export function ConditionalRenderer({
  condition,
  children,
}: PropsWithChildren<{
  condition: boolean;
}>) {
  return condition ? children : null;
}
